// Audit log rows as both sites show them (admin site: every agency; agency app: its own).
export interface AuditEntry {
  auditId: number;
  occurredAt: string;
  agencyId: string | null;
  agencyName: string | null;
  actorUserId: string | null;
  actorName: string | null;
  actorEmail: string | null;
  action: string;
  entityType: string;
  entityId: string;
  detail: unknown;
}

export const AUDIT_LABELS: Record<string, string> = {
  'agency.created': 'Agency created',
  'agency.suspended': 'Agency suspended',
  'agency.reactivated': 'Agency reactivated',
  'membership.invited': 'Person invited',
  'membership.activated': 'Invitation accepted (first sign-in)',
  'membership.updated': 'Role or access changed',
  'membership.visibility': 'Quote visibility changed',
  'membership.offboarded': 'Person deactivated, work transferred',
  'membership.work-transferred': 'Work moved from a suspended person',
  'intake.created': 'Quote request submitted',
  'intake.assigned': 'Quote request assigned',
  'intake.claimed': 'Quote request claimed',
  'opportunity.created': 'Quote created',
  'opportunity.updated': 'Quote changed',
  'opportunity.archived': 'Quote archived',
  'opportunity.restored': 'Quote restored from the archive',
  'intake.archived': 'Quote request archived',
  'intake.restored': 'Quote request restored from the archive',
  'call.created': 'Phone call logged',
  'call.updated': 'Phone call updated',
  'link.created': 'Resource link added',
  'link.updated': 'Resource link changed',
  'link.deleted': 'Resource link removed',
  'sample-data.loaded': 'Sample data loaded',
  'document.added': 'Document added',
  'document.removed': 'Document removed',
  'document.restored': 'Document restored',
};

/** Short, readable summary of the detail JSON (never the raw blob). */
export function describeAudit(detail: unknown): string {
  if (!detail || typeof detail !== 'object') return '';
  return Object.entries(detail as Record<string, unknown>)
    .filter(([, v]) => v !== null && v !== undefined && !(Array.isArray(v) && v.length === 0))
    .map(([k, v]) => `${k}: ${Array.isArray(v) ? v.join('; ') : typeof v === 'object' ? JSON.stringify(v) : String(v)}`)
    .join(' · ')
    .slice(0, 300);
}

export const auditWhen = (iso: string) => new Date(iso).toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' });
